import { useRouter } from "next/router";
import NextImage from "../global/NextImage";

const Logo = ({className}) => {
  const { locale } = useRouter();
  return (   
        <NextImage
          src={`/imgs/aw_logo_${locale}.png`}
          width={100}
          height={100}
          className={`w-24 transition-all duration-500 object-contain ${className || ''}`}
        />  );
};
export default Logo;
